// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2usG1","search":"Settings_search__1qiye","filter":"Settings_filter__3kUEy"};